import { Auth0Provider, Auth0ProviderOptions } from "@auth0/auth0-react";
import { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";

import { AnimatedRoutes } from "./router";

function App() {
  const oidcConfig: Auth0ProviderOptions = {
    domain: import.meta.env.VITE_AUTH0_URL,
    clientId: import.meta.env.VITE_AUTH0_CLIENTID,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      scope: "openid profile email offline_access",
    },
    useRefreshTokens: true,
    cacheLocation: "localstorage",
  };

  return (
    <StrictMode>
      <Auth0Provider {...oidcConfig}>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            className: "custom-toast",
          }}
        />
        <BrowserRouter>
          {/* <QueryParamProvider adapter={ReactRouter6Adapter}> */}
          <AnimatedRoutes isAppInitialized={true} />
          {/* </QueryParamProvider> */}
        </BrowserRouter>
      </Auth0Provider>
    </StrictMode>
  );
}

export default App;
